
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge",
      function () {
        return require("private-next-pages/knowledge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge"])
      });
    }
  